// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"zV-z","inlineTitle":"AV-z","sponsoredAdsWrapper":"BV-z","marketplaceRecosWrapper":"CV-z"};